import CSSModules from "react-css-modules";
import styles from "./MobileBanner.scss";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {injectIntl, intlShape } from "react-intl";
import {isMobilePhone, isAndroidDevice, isIPhone, getBrowserType} from "../../utils/mobileHelper"
import { datadogRum } from '@datadog/browser-rum';
import { ANDROID_STORE_URL, IOS_STORE_URL } from "../../constants/sunbit";

@injectIntl
@CSSModules(styles)
class MobileBanner extends Component {
    static propTypes = {
        intl: intlShape,
        bannerMessage: PropTypes.string,
        downloadBtnLabel: PropTypes.string,
        bannerStyle: PropTypes.oneOf(["dark", "bright"]),
        currentUserId: PropTypes.number
    };

    constructor(props) {
        super(props);
        let showMobileBanner = this.toShowMobileBanner();

        this.state = {
            showMobileBanner
        };
    }

    toShowMobileBanner(){
        if(isMobilePhone()){
            if(isAndroidDevice()){
                return true;
            } else if(isIPhone()) {
                const browserType = getBrowserType();
                if(/safari/i.test(browserType)){
                    this.showIOSSmartBanner()
                    return false;
                } else {
                    return true;
                }
            }
        } else{
            return false;
        }
    }


    showIOSSmartBanner(){
        let previousMetaNode = document.querySelector('meta[name="apple-itunes-app"]');
        if(!previousMetaNode){
            let headNode = document.getElementsByTagName("head")[0];
            let sbNode = document.createElement('meta');
            sbNode.name = 'apple-itunes-app';
            sbNode.content = 'app-id=1551590090';
            headNode.appendChild(sbNode);
        }
    }

    closeMobileBanner() {
        this.setState({ showMobileBanner: false });
    }

    downloadMobileApp() {
        datadogRum.addUserAction('DownloadAppBanner', {
            event: {
              actionMessage: `User click on download App -  ${this.props.currentUserId? 'Post-Login' : 'Pre-Login'}`,
            },
          customerId: this.props.currentUserId || -1,
        });
        if(isAndroidDevice()){
            window.location = ANDROID_STORE_URL;
        } else if(isIPhone()) {
            window.location = IOS_STORE_URL;
        }
    }

    render() {
        const {
            intl: { formatMessage }
          } = this.props;
        return this.state.showMobileBanner ? (<div className={`${styles.mobileBanner} ${this.props.bannerStyle ? styles[this.props.bannerStyle] : ''}`}>
            <div className={styles.closeBanner} onClick={this.closeMobileBanner.bind(this)}></div>
            <div className={styles.sunbitLogo}></div>
            <div className={styles.bannerMessageContainer}>
                {this.props.bannerMessage ? formatMessage({id: this.props.bannerMessage}) : ''}
            </div>
            <div className={styles.downloadAppBtnContainer} onClick={this.downloadMobileApp.bind(this)}>
                {this.props.downloadBtnLabel ? formatMessage({id: this.props.downloadBtnLabel }) : ''}
            </div>
        </div>) : null;
    }

}


export default MobileBanner;



// WEBPACK FOOTER //
// ./src/components/banners/MobileBanner.js